import { Text, Tab } from '@/ui'
import DocumentsTable from './DocumentsTable'
import { UserWithAdminInfo } from '@/reducers/admin/allUsersReducer'
import { UploadDocumentType } from '@/constants/businessConstants'
import { TypographyStyles } from '@/styles'
import { useState } from 'react'

interface Props {
  user: UserWithAdminInfo
}

export const Documents = ({ user }: Props) => {
  const [activeTab, setActiveTab] = useState(0)

  const panes = [
    {
      menuItem: 'Bank Statements',
      render: () => (
        <DocumentsTable
          user={user}
          documentType={UploadDocumentType.STATEMENT}
        />
      ),
    },
    {
      menuItem: 'Bookkeeping',
      render: () => (
        <DocumentsTable
          user={user}
          documentType={UploadDocumentType.BOOKKEEPING}
        />
      ),
    },
    {
      menuItem: 'Tax',
      render: () => (
        <DocumentsTable user={user} documentType={UploadDocumentType.TAX} />
      ),
    },
    {
      menuItem: 'Incorporation',
      render: () => (
        <DocumentsTable
          user={user}
          documentType={UploadDocumentType.INCORPORATION}
        />
      ),
    },
    {
      menuItem: 'Receipts',
      render: () => (
        <DocumentsTable user={user} documentType={UploadDocumentType.RECEIPT} />
      ),
    },
    {
      menuItem: 'Other',
      render: () => (
        <DocumentsTable user={user} documentType={UploadDocumentType.OTHER} />
      ),
    },
  ]

  return (
    <div>
      <br />
      <Text variant={TypographyStyles.H2} className="mb-2">
        User Documents
      </Text>
      <Tab
        panes={panes}
        defaultActiveIndex={activeTab}
        onTabClick={setActiveTab}
        variant="outline"
      />
    </div>
  )
}
